import React, { useState, useCallback } from 'react';

const S = {
  panel: { margin: '0 auto 24px', maxWidth: '900px', padding: '14px 18px', background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', userSelect: 'none' },
  title: { margin: 0, color: '#daa520', fontSize: '0.95rem' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', padding: '8px 10px', borderBottom: '1px solid #222', fontSize: '0.85rem', flexWrap: 'wrap' },
};

export default function StockHistory({ backendUrl }) {
  const [expanded, setExpanded] = useState(false);
  const [movements, setMovements] = useState(null);

  const fetchMovements = useCallback(async () => {
    try {
      const res = await fetch(`${backendUrl}/api/admin/stock-movements?limit=100`);
      const data = await res.json();
      setMovements(data.movements || []);
    } catch (e) {
      setMovements([]);
    }
  }, [backendUrl]);

  const toggle = () => {
    const next = !expanded;
    setExpanded(next);
    if (next) fetchMovements();
  };

  const fmtDate = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch (e) { return iso; }
  };

  return (
    <div style={S.panel} data-testid="stock-history-panel">
      <div style={S.header} onClick={toggle} data-testid="toggle-stock-history">
        <h3 style={S.title}>📦 Histórico de Stock <span style={{ color: '#888', fontWeight: 'normal', fontSize: '0.82rem' }}>(vendas, reposições, ajustes)</span></h3>
        <span style={{ color: '#daa520', fontSize: '1.1rem' }}>{expanded ? '▼' : '▶'}</span>
      </div>
      {expanded && (
        <div style={{ marginTop: '12px', maxHeight: '420px', overflowY: 'auto' }} data-testid="stock-history-list">
          {movements === null ? (
            <p style={{ color: '#888' }}>A carregar…</p>
          ) : movements.length === 0 ? (
            <p style={{ color: '#888', fontStyle: 'italic' }}>Nenhum movimento registado ainda. Os movimentos aparecem aqui a partir de agora (cada venda, reposição ou ajuste manual).</p>
          ) : movements.map((m) => (
            <div key={m.id} style={S.row} data-testid={`stock-movement-${m.id}`}>
              <span style={{ color: '#888', minWidth: '120px' }}>{fmtDate(m.created_at)}</span>
              <span style={{ color: '#fff', flex: 1, minWidth: '160px' }}>{m.product_name}</span>
              <span style={{ color: m.change < 0 ? '#ff6666' : '#44cc44', fontWeight: 700, minWidth: '40px', textAlign: 'right' }}>
                {m.change > 0 ? `+${m.change}` : m.change}
              </span>
              <span style={{ color: '#aaa', minWidth: '70px' }}>{m.old_stock} → {m.new_stock}</span>
              <span style={{ color: '#daa520', fontSize: '0.78rem' }}>{m.reason}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
